/**
 * VRG-361 — a ROW-LEVEL marker that a record is not real customer data.
 *
 * Mirrors the `enum_example_kind` Postgres type. `null` (or an absent field)
 * means REAL customer data, which is the overwhelmingly common case.
 *
 * Two members rather than a boolean, because two kinds of not-real data have to
 * share one mechanism and they are not interchangeable:
 *
 * - `demo`  — provisioned from a prospect's public website for cold outbound.
 *   Scraped imagery and guessed copy; a takedown request is meaningful.
 * - `intro` — sample/onboarding data Vera gives a company to explore with. Ours
 *   to create, so a takedown request is meaningless.
 *
 * Both are excluded from metering and both render the "not real data" badge.
 */
export type ExampleKind = 'demo' | 'intro';

/**
 * The badge's user-facing label, per kind. One source so the table cells, the
 * detail-page headers and any future surface cannot drift apart (§36).
 */
export const EXAMPLE_KIND_LABEL: Record<ExampleKind, string> = {
  demo: 'Demo data',
  intro: 'Sample data',
};

/**
 * The badge's hover copy. States both halves the reader needs: it is not real,
 * and it is not charged for. Kept short (§25) and free of em-dashes (§15).
 */
export const EXAMPLE_KIND_TOOLTIP: Record<ExampleKind, string> = {
  demo: 'Added by Vera to demonstrate the product. Not your data, and never billed.',
  intro: 'Sample data to explore with. Not your data, and never billed.',
};
